/* Adela Sevilla — interacciones del tema (vanilla JS, sin librerías) */
/* Guard: el archivo puede incluirse varias veces en la página (varias secciones lo cargan).
   Este candado asegura que la inicialización se ejecute UNA sola vez y evita manejadores duplicados. */
if (!window.__mtInit) {
  window.__mtInit = true;
  // Marca que el JS está activo (la opacidad 0 del reveal solo aplica con esta clase).
  document.documentElement.classList.add('mt-js');
  var mtBoot = function () {
    initReveal();
    initFaq();
    initGaleriaProducto();
    initVariantes();
    initContador();
    initCarruseles();
    initBarraFija();
    initZoomImagen();
    initQuiz();
    initContadorPromo();
    // Red de seguridad: si por lo que sea el observer no revela algo, lo mostramos igualmente.
    setTimeout(function () {
      var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
      for (var i = 0; i < els.length; i++) { els[i].classList.add('mt-visible'); }
    }, 2500);
  };
  // Arranca ya si el DOM está listo; si no, al terminar de cargar. (Evita quedarse sin
  // ejecutar cuando el script corre después de DOMContentLoaded.)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mtBoot);
  } else {
    mtBoot();
  }
}

/* Revela elementos .mt-reveal / .mt-reveal-stagger al hacer scroll */
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

/* Acordeón de preguntas frecuentes */
function initFaq() {
  var items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.mt-faq-pregunta');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-faq-abierto');
      items.forEach(function (i) { i.classList.remove('mt-faq-abierto'); });
      if (!abierto) item.classList.add('mt-faq-abierto');
    });
  });
}

/* Galería de la página de producto: miniatura -> imagen principal */
function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-mt-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.style.opacity = '0';
        window.setTimeout(function () {
          principal.setAttribute('src', src);
          principal.style.opacity = '1';
        }, 150);
        minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
        mini.classList.add('mt-mini-activa');
      });
    });
  });
}

/* Selector de variantes de producto: actualiza precio, id y disponibilidad */
function initVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var inputId = form.querySelector('input[name="id"]');
    var botonesOpcion = form.querySelectorAll('[data-mt-opcion]');
    var preciosEl = form.querySelectorAll('[data-mt-precio]');
    var preciosCompareEl = form.querySelectorAll('[data-mt-precio-comparado]');
    var botonesComprar = form.querySelectorAll('[data-mt-boton-comprar]');

    function opcionesSeleccionadas() {
      var seleccion = [];
      var grupos = {};
      form.querySelectorAll('[data-mt-opcion].mt-opcion-activa').forEach(function (b) {
        grupos[b.getAttribute('data-mt-opcion-index')] = b.getAttribute('data-mt-valor');
      });
      var maxIndex = 0;
      botonesOpcion.forEach(function (b) {
        maxIndex = Math.max(maxIndex, parseInt(b.getAttribute('data-mt-opcion-index'), 10));
      });
      for (var i = 0; i <= maxIndex; i++) seleccion.push(grupos[i]);
      return seleccion;
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var variante = variantes.find(function (v) {
        return v.options.every(function (val, idx) { return val === seleccion[idx]; });
      });
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      preciosEl.forEach(function (el) { el.textContent = formatearDinero(variante.price); });
      preciosCompareEl.forEach(function (el) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          el.textContent = formatearDinero(variante.compare_at_price);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
      botonesComprar.forEach(function (botonComprar) {
        if (variante.available) {
          botonComprar.disabled = false;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-disponible') || 'Añadir al carrito';
        } else {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado') || 'Agotado';
        }
      });
      // Cambiar la foto principal a la del color/variante seleccionado
      if (variante.imagen) {
        var principalImg = document.querySelector('[data-mt-imagen-principal]');
        if (principalImg && principalImg.getAttribute('src') !== variante.imagen) {
          principalImg.style.opacity = '0';
          window.setTimeout(function () {
            principalImg.setAttribute('src', variante.imagen);
            principalImg.style.opacity = '1';
          }, 150);
          document.querySelectorAll('[data-mt-mini]').forEach(function (m) {
            m.classList.toggle('mt-mini-activa', m.getAttribute('data-full') === variante.imagen);
          });
        }
      }
      // Actualizar el indicador de stock según la variante
      var stock = document.querySelector('[data-mt-stock]');
      if (stock) {
        var stockTexto = stock.querySelector('[data-mt-stock-texto]');
        var stockRelleno = stock.querySelector('[data-mt-stock-relleno]');
        var fila = stock.querySelector('.mt-stock-fila');
        fila.classList.remove('mt-stock-bajo', 'mt-stock-agotado');
        if (!variante.available) {
          fila.classList.add('mt-stock-agotado');
          if (stockTexto) stockTexto.textContent = 'Agotado temporalmente';
          if (stockRelleno) stockRelleno.style.width = '0%';
        } else {
          var n = (variante.id % 5) + 4;
          fila.classList.add('mt-stock-bajo');
          if (stockTexto) stockTexto.innerHTML = '¡Date prisa! Solo quedan <b>' + n + '</b> unidades';
          if (stockRelleno) stockRelleno.style.width = Math.round(n / 15 * 100) + '%';
        }
      }
    }

    function formatearDinero(centavos) {
      return (centavos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    botonesOpcion.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grupo = btn.getAttribute('data-mt-opcion-index');
        form.querySelectorAll('[data-mt-opcion-index="' + grupo + '"]').forEach(function (b) {
          b.classList.remove('mt-opcion-activa');
        });
        btn.classList.add('mt-opcion-activa');
        actualizar();
      });
    });

    actualizar();
  });
}

/* Cifras animadas (count-up) al entrar en pantalla */
function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseInt(el.getAttribute('data-mt-contador'), 10) || 0;
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = Math.floor(progreso * fin);
        el.textContent = valor.toLocaleString('es-ES');
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toLocaleString('es-ES');
      }
      requestAnimationFrame(paso);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

/* Barra fija de compra: aparece cuando el botón principal sale de pantalla */
function initBarraFija() {
  var barra = document.querySelector('[data-mt-barra-fija]');
  var principal = document.querySelector('[data-mt-boton-principal]');
  if (!barra || !principal || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting || entry.boundingClientRect.top > 0) {
        barra.classList.remove('mt-barra-visible');
        document.body.classList.remove('mt-con-barra');
      } else {
        barra.classList.add('mt-barra-visible');
        document.body.classList.add('mt-con-barra');
      }
    });
  }, { threshold: 0 });
  observer.observe(principal);
}

/* Zoom de la imagen principal del producto al mover el ratón */
function initZoomImagen() {
  var contenedores = document.querySelectorAll('.mt-producto-imagen-principal');
  contenedores.forEach(function (cont) {
    var img = cont.querySelector('img');
    if (!img) return;
    if (window.matchMedia('(hover: none)').matches) return;
    cont.addEventListener('mouseenter', function () { cont.classList.add('mt-zoom-activo'); });
    cont.addEventListener('mouseleave', function () {
      cont.classList.remove('mt-zoom-activo');
      img.style.transformOrigin = 'center';
    });
    cont.addEventListener('mousemove', function (e) {
      var r = cont.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });
  });
}

/* Cuenta atrás de la promoción: por visitante, se reinicia sola al llegar a 0 */
function initContadorPromo() {
  var contadores = document.querySelectorAll('[data-mt-promo-contador]');
  if (!contadores.length) return;
  contadores.forEach(function (cont) {
    var horas = parseInt(cont.getAttribute('data-horas'), 10) || 24;
    var duracion = horas * 3600 * 1000;
    var clave = 'mtPromoFin';
    var fin;
    try {
      fin = parseInt(window.localStorage.getItem(clave), 10);
    } catch (e) { fin = 0; }
    if (!fin || isNaN(fin) || fin - Date.now() <= 0 || fin - Date.now() > duracion) {
      fin = Date.now() + duracion;
      try { window.localStorage.setItem(clave, String(fin)); } catch (e) {}
    }
    var elH = cont.querySelector('[data-mt-ch]');
    var elM = cont.querySelector('[data-mt-cm]');
    var elS = cont.querySelector('[data-mt-cs]');
    function dosDigitos(n) { return (n < 10 ? '0' : '') + n; }
    function tic() {
      var resta = fin - Date.now();
      if (resta <= 0) {
        fin = Date.now() + duracion;
        try { window.localStorage.setItem(clave, String(fin)); } catch (e) {}
        resta = duracion;
      }
      var s = Math.floor(resta / 1000);
      var h = Math.floor(s / 3600);
      var m = Math.floor((s % 3600) / 60);
      var seg = s % 60;
      if (elH) elH.textContent = dosDigitos(h);
      if (elM) elM.textContent = dosDigitos(m);
      if (elS) elS.textContent = dosDigitos(seg);
    }
    tic();
    window.setInterval(tic, 1000);
  });
}

/* Quiz de recomendación: pasos, conteo de respuestas y resultado */
function initQuiz() {
  var quizzes = document.querySelectorAll('[data-mt-quiz]');
  quizzes.forEach(function (quiz) {
    var pantallas = quiz.querySelectorAll('[data-mt-pantalla]');
    var progreso = quiz.querySelector('[data-mt-progreso]');
    var totalPasos = parseInt(quiz.getAttribute('data-total-pasos'), 10) || 0;
    var ctaDefecto = quiz.getAttribute('data-cta-defecto') || '/collections/all';
    var respuestas = [];

    function mostrar(selectorFn) {
      pantallas.forEach(function (p) { p.classList.remove('mt-quiz-activa'); });
      var destino = selectorFn();
      if (destino) {
        destino.classList.add('mt-quiz-activa');
        // reinicia la animación de entrada
        destino.style.animation = 'none';
        void destino.offsetWidth;
        destino.style.animation = '';
      }
    }

    function pantallaPaso(indice) {
      return quiz.querySelector('[data-mt-pantalla="paso"][data-indice="' + indice + '"]');
    }

    function actualizarProgreso(indice) {
      if (!progreso || totalPasos === 0) return;
      var pct = Math.round((indice / totalPasos) * 100);
      progreso.style.width = pct + '%';
    }

    function irAPaso(indice) {
      if (indice >= totalPasos) { calcularResultado(); return; }
      actualizarProgreso(indice);
      mostrar(function () { return pantallaPaso(indice); });
    }

    function calcularResultado() {
      if (progreso) progreso.style.width = '100%';
      mostrar(function () { return quiz.querySelector('[data-mt-pantalla="cargando"]'); });
      window.setTimeout(function () {
        var conteo = {};
        respuestas.forEach(function (v) {
          if (!v) return;
          conteo[v] = (conteo[v] || 0) + 1;
        });
        var ganador = null, max = -1, empate = false;
        Object.keys(conteo).forEach(function (k) {
          if (conteo[k] > max) { max = conteo[k]; ganador = k; empate = false; }
          else if (conteo[k] === max) { empate = true; }
        });
        var resultados = quiz.querySelectorAll('[data-mt-pantalla="resultado"]');
        var elegido = null;
        if (ganador && !empate) {
          resultados.forEach(function (r) {
            if (r.getAttribute('data-resultado-id') === ganador) elegido = r;
          });
        }
        if (!elegido) {
          // empate o sin coincidencia: usa "todo" si existe, si no el primero
          resultados.forEach(function (r) {
            if (!elegido && r.getAttribute('data-resultado-id') === 'todo') elegido = r;
          });
          if (!elegido && resultados.length) elegido = resultados[0];
        }
        if (elegido) {
          var cta = elegido.querySelector('.mt-quiz-cta');
          if (cta && (!cta.getAttribute('href') || cta.getAttribute('href') === '/collections/all')) {
            // deja el enlace configurado; si no hay, cae al por defecto
            if (!cta.getAttribute('href')) cta.setAttribute('href', ctaDefecto);
          }
          mostrar(function () { return elegido; });
          try { quiz.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        }
      }, 900);
    }

    // Empezar
    var btnEmpezar = quiz.querySelector('[data-mt-empezar]');
    if (btnEmpezar) btnEmpezar.addEventListener('click', function () { respuestas = []; irAPaso(0); });

    // Opciones de cada paso
    quiz.querySelectorAll('[data-mt-pantalla="paso"]').forEach(function (paso) {
      var indice = parseInt(paso.getAttribute('data-indice'), 10);
      paso.querySelectorAll('[data-mt-opcion]').forEach(function (opcion) {
        opcion.addEventListener('click', function () {
          paso.querySelectorAll('[data-mt-opcion]').forEach(function (o) { o.classList.remove('mt-quiz-elegida'); });
          opcion.classList.add('mt-quiz-elegida');
          respuestas[indice] = opcion.getAttribute('data-valor');
          window.setTimeout(function () { irAPaso(indice + 1); }, 380);
        });
      });
      // Atrás
      var atras = paso.querySelector('[data-mt-atras]');
      if (atras) atras.addEventListener('click', function () {
        if (indice === 0) { mostrar(function () { return quiz.querySelector('[data-mt-pantalla="inicio"]'); }); actualizarProgreso(0); }
        else irAPaso(indice - 1);
      });
    });

    // Reiniciar
    quiz.querySelectorAll('[data-mt-reiniciar]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        respuestas = [];
        quiz.querySelectorAll('.mt-quiz-elegida').forEach(function (o) { o.classList.remove('mt-quiz-elegida'); });
        actualizarProgreso(0);
        mostrar(function () { return quiz.querySelector('[data-mt-pantalla="inicio"]'); });
      });
    });
  });
}

/* Carrusel horizontal simple con flechas (sin librerías) */
function initCarruseles() {
  var carruseles = document.querySelectorAll('[data-mt-carrusel]');
  carruseles.forEach(function (carrusel) {
    var pista = carrusel.querySelector('[data-mt-pista]');
    var prev = carrusel.querySelector('[data-mt-prev]');
    var next = carrusel.querySelector('[data-mt-next]');
    if (!pista) return;
    var paso = function () {
      var primero = pista.querySelector(':scope > *');
      return primero ? primero.getBoundingClientRect().width + 20 : 300;
    };
    if (next) next.addEventListener('click', function () {
      pista.scrollBy({ left: paso(), behavior: 'smooth' });
    });
    if (prev) prev.addEventListener('click', function () {
      pista.scrollBy({ left: -paso(), behavior: 'smooth' });
    });
  });
}

/* Cuenta atrás de oferta (hasta el fin del día) — estilo Natalia */
(function () {
  var t = document.querySelector('[data-mt-timer]');
  if (!t) return;
  var h = t.querySelector('[data-mt-h]'), m = t.querySelector('[data-mt-m]'), s = t.querySelector('[data-mt-s]');
  function p(n){ return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = new Date(), end = new Date();
    end.setHours(23, 59, 59, 999);
    var d = Math.max(0, Math.floor((end - now) / 1000));
    if (h) h.textContent = p(Math.floor(d / 3600));
    if (m) m.textContent = p(Math.floor((d % 3600) / 60));
    if (s) s.textContent = p(d % 60);
  }
  tick();
  setInterval(tick, 1000);
})();
